export default "__VITE_ASSET__BrEkOhR3__";